import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import * as configActions from 'modules/config';
import * as adminActions from 'modules/admin';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';

import { SmtpTest } from 'components';

class CtSmtpTest extends Component {
  constructor(props) {
    super(props);

    this.state = { onProgress: false };
  }

  checkSmtp = async () => {
    this.setState({ onProgress: true });

    const { isAuth, AdminActions, ConfigActions } = this.props;

    try {
      if (isAuth === 2) {
        await AdminActions.checkSmtp();
      } else {
        await ConfigActions.checkSmtp();
      }
    } catch (e) {
      console.log(e);
    }

    this.setState({ onProgress: false });
  };

  render() {
    const { onProgress } = this.state;
    const { mailSmtpTested } = this.props;
    const { checkSmtp } = this;

    return <SmtpTest checkSmtp={checkSmtp} mailSmtpTested={mailSmtpTested} onProgress={onProgress} />;
  }
}

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch),
  AdminActions: bindActionCreators(adminActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtSmtpTest);



// WEBPACK FOOTER //
// ./src/script/containers/config/CtSmtpTest.js